import * as React from 'react';
import Layout from '../../components/Utilities/Layout';
import { Alert, AlertTitle, Box, Button, ButtonProps, Dialog, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, Stack, Typography } from '@mui/material';
import SecurityTrimmer from '../../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../../utilities/Permisos';
import EntityPermissions from '../../components/EntityPermissions';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import ReactInterval from 'react-interval';
import Common from '../../utilities/common';
import $ from "jquery";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import { GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector, useGridApiContext, GridCsvExportOptions, GridToolbarContainer, DataGrid } from '@mui/x-data-grid';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const CustomToolbar = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
      <GridToolbarContainer>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'ipdatalog' })}
        >
          Exportar CSV
        </Button>
      </GridToolbarContainer>
    );
}

export interface IIpsProgressState {
    progressData: any;
    logData: any[];
    openDialog: boolean;
}

export default class IpsProgress extends React.Component<{}, IIpsProgressState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            progressData: null,
            logData: [],
            openDialog: false
        }
    }

    componentDidMount(): void {
        this.GetProgress();
    }

    public render(): React.ReactElement<{}> {
        return (
            <SecurityTrimmer entity={Entity.IPS} permission={PermissionLevel.SuperAdministrar} noAccessMessage='No tiene permisos para ver este contenido.'>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Configuración',
                            url: '/settings'
                        },
                        {
                            title: 'IPs',
                            url: '/settings/ips'
                        },
                        {
                            title: 'Progreso de asignación de IPs',
                            url: ''
                        }
                    ]
                }>
                    <ReactInterval timeout={5} enabled={true} callback={() => {
                        this.GetProgress();
                        this.GetLog();
                    }}/>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <LanguageOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                Progreso de asignación de IPs
                                </Typography>
                            </Grid>
                            <SecurityTrimmer entity={Entity.IPS} permission={PermissionLevel.SuperAdministrar}>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntityPermissions entity={Entity.IPS}/>
                                </Grid>
                            </SecurityTrimmer>
                        </Grid>
                    </Box>
                    <Box className='main'>
                        {
                            this.state.progressData != null && this.state.progressData.status == 'Finalizado' && (
                                <Alert severity="success">
                                    <AlertTitle>Finalizado</AlertTitle>
                                    <Stack direction={'row'}>
                                        <Typography variant='body2' component={'div'} style={{marginRight: '20px'}}>
                                            <CalendarMonthOutlinedIcon style={{position: 'relative', top: '5px', marginRight: '5px'}}/>
                                            {
                                                `${new Date(this.state.progressData.date).toLocaleDateString()} ${new Date(this.state.progressData.date).toLocaleTimeString()}`
                                            }
                                        </Typography>
                                        <Typography variant='body2' component={'div'} style={{marginRight: '20px'}}>
                                            <PlayCircleOutlineOutlinedIcon style={{position: 'relative', top: '5px', marginRight: '5px'}}/>
                                            {
                                                `${new Date(this.state.progressData.startTime).toLocaleDateString()} ${new Date(this.state.progressData.startTime).toLocaleTimeString()}`
                                            }
                                        </Typography>
                                        <Typography variant='body2' component={'div'}>
                                            <StopCircleOutlinedIcon style={{position: 'relative', top: '5px', marginRight: '5px'}}/>
                                            {
                                                `${new Date(this.state.progressData.endTime).toLocaleDateString()} ${new Date(this.state.progressData.endTime).toLocaleTimeString()}`
                                            }
                                        </Typography>
                                    </Stack>
                                </Alert>
                            )
                        }
                        {
                            this.state.progressData != null && this.state.progressData.status == 'Error' && (
                                <Alert severity="error">
                                    <AlertTitle>Error</AlertTitle>
                                    <Stack direction={'row'}>
                                        <Typography variant='body2' component={'div'} style={{marginRight: '20px'}}>
                                            <CalendarMonthOutlinedIcon style={{position: 'relative', top: '5px', marginRight: '5px'}}/>
                                            {
                                                `${new Date(this.state.progressData.date).toLocaleDateString()} ${new Date(this.state.progressData.date).toLocaleTimeString()}`
                                            }
                                        </Typography>
                                        <Typography variant='body2' component={'div'} style={{marginRight: '20px'}}>
                                            <PlayCircleOutlineOutlinedIcon style={{position: 'relative', top: '5px', marginRight: '5px'}}/>
                                            {
                                                `${new Date(this.state.progressData.startTime).toLocaleDateString()} ${new Date(this.state.progressData.startTime).toLocaleTimeString()}`
                                            }
                                        </Typography>
                                        <Typography variant='body2' component={'div'}>
                                            <StopCircleOutlinedIcon style={{position: 'relative', top: '5px', marginRight: '5px'}}/>
                                            {
                                                `${new Date(this.state.progressData.endTime).toLocaleDateString()} ${new Date(this.state.progressData.endTime).toLocaleTimeString()}`
                                            }
                                        </Typography>
                                    </Stack>
                                </Alert>
                            )
                        }
                        {
                            this.state.progressData != null && this.state.progressData.status == 'Pendiente' && (
                                <Alert severity="warning">
                                    <AlertTitle>Pendiente</AlertTitle>
                                    <Stack direction={'row'}>
                                        <Typography variant='body2' component={'div'} style={{marginRight: '20px'}}>
                                            <CalendarMonthOutlinedIcon style={{position: 'relative', top: '5px', marginRight: '5px'}}/>
                                            {
                                                `${new Date(this.state.progressData.date).toLocaleDateString()} ${new Date(this.state.progressData.date).toLocaleTimeString()}`
                                            }
                                        </Typography>
                                    </Stack>
                                </Alert>
                            )
                        }
                        {
                            this.state.progressData != null && this.state.progressData.status == 'En proceso' && (
                                <React.Fragment>
                                    <Alert severity="info">
                                        <AlertTitle>En proceso</AlertTitle>
                                        <Stack direction={'row'}>
                                            <Typography variant='body2' component={'div'} style={{marginRight: '20px'}}>
                                                <CalendarMonthOutlinedIcon style={{position: 'relative', top: '5px', marginRight: '5px'}}/>
                                                {
                                                    `${new Date(this.state.progressData.date).toLocaleDateString()} ${new Date(this.state.progressData.date).toLocaleTimeString()}`
                                                }
                                            </Typography>
                                            <Typography variant='body2' component={'div'} style={{marginRight: '20px'}}>
                                                <PlayCircleOutlineOutlinedIcon style={{position: 'relative', top: '5px', marginRight: '5px'}}/>
                                                {
                                                    `${new Date(this.state.progressData.startTime).toLocaleDateString()} ${new Date(this.state.progressData.startTime).toLocaleTimeString()}`
                                                }
                                            </Typography>
                                        </Stack>
                                    </Alert>
                                    <Box sx={{ display: 'flex', alignItems: 'center'}}>
                                        <Box sx={{ width: '100%', mr: 1 }}>
                                            <LinearProgress variant="determinate" color='info' value={this.state.progressData.progress} />
                                        </Box>
                                        <Box sx={{ minWidth: 35 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                {
                                                    `${this.state.progressData.progress}%`
                                                }
                                            </Typography>
                                        </Box>
                                    </Box>
                                </React.Fragment>
                            )
                        }
                        {
                            this.state.progressData != null && this.state.progressData.status != 'Pendiente' && (
                                <DataGrid
                                    style={{marginTop: '20px'}}
                                    autoHeight
                                    slots={{ toolbar: CustomToolbar }}
                                    slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                    hideFooter={this.state.logData.length <= 30}
                                    rows={this.state.logData}
                                    columns={[
                                        { 
                                            field: 'date', 
                                            headerName: 'Fecha', 
                                            width: 200 
                                        },
                                        { 
                                            field: 'message', 
                                            headerName: 'Mensaje', 
                                            width: 800 
                                        }
                                    ]}
                                    initialState={{
                                        pagination: {
                                            paginationModel: { page: 0, pageSize: 30 },
                                        },
                                    }}
                                    pageSizeOptions={[30, 60, 100]}
                                />
                            )
                        }
                    </Box>
                    <Box className='stepper textRight'>
                        <Button variant="contained" onClick={() => {
                            this.setState(
                                {
                                    openDialog: true
                                }
                            );
                        }}>
                            Iniciar asignación de IPs
                        </Button>
                    </Box>
                    <Dialog open={this.state.openDialog} fullWidth>
                        <DialogTitle>
                            Iniciar asignación de IPs
                        </DialogTitle>
                        <DialogContent>
                            <Typography variant='body2'>
                                Va a iniciar el proceso de asignación de IPs a los registros de datos. Esta acción sobreescribirá las IPs asignadas a los registros.
                            </Typography>
                            <Typography variant='body2'>
                                ¿Desea continuar?
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.Start.bind(this)}>OK</Button>
                            <Button onClick={() => {
                                this.setState(
                                    {
                                        openDialog: false
                                    }
                                );
                            }}>Cancelar</Button>
                        </DialogActions>
                    </Dialog>
                </Layout>
            </SecurityTrimmer>
        )
    }

    private GetProgress() {
        let url = `${Common.END_POINT}/masters/ip/data/progress`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    progressData: response[0]
                }
            );
        })
    }

    private GetLog() {
        let url = `${Common.END_POINT}/masters/ip/data/progress/log`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    logData: response
                }
            );
        })
    }

    private Start() {
        let url = `${Common.END_POINT}/masters/ip/data/progress/start`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            this.GetProgress();
            this.GetLog();
            this.setState(
                {
                    openDialog: false
                }
            )
        })
    }
}